import "./label.css";

export const Label = ({children}) => {
    return (
        <div className="label">
            <p className="body3">{children}</p>
        </div>
    )
}